import { render } from "./emoji_picker.vue?vue&type=template&id=4f641be7"
import script from "./emoji_picker.js?vue&type=script&lang=js"
export * from "./emoji_picker.js?vue&type=script&lang=js"

import "./emoji_picker.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__